export default [{
  path: '/dashboards-cobrancas',
  name: 'dashboard-cobranca',
  component: () => import('@/app-modulo/documento/dashboard-cobranca/DashboardCobranca.vue'),
  meta: {
    resource: 'dashboardcobranca',
    action: 'read',
    navActiveLink: 'dashboard-cobranca',
    pageTitle: 'Dashboard de Cobrança',
  },
}]
